import { NgModule } from "@angular/core";
import { AgecalculatePipe } from "./agecalculate.pipe";


@NgModule({
    declarations: [AgecalculatePipe],
    imports: [],
    exports: [AgecalculatePipe]
})
export class PipesModule { }